/**
 * Book-card renderer.
 *
 * Takes the catalog from the data module and populates a <ul> with one
 * <li class="book_card"> per book. Keeps the markup out of the static
 * HTML so adding a new title is a one-line change to the data file.
 */

import { books, series } from './data/content.js';

/** Inline ornament, kept tiny and reused across placeholders. */
function ornamentSvg() {
  return `
    <svg class="book_cover_ornament" viewBox="0 0 60 8" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
      <line x1="0" y1="4" x2="22" y2="4" stroke="currentColor" stroke-width="0.8"/>
      <line x1="38" y1="4" x2="60" y2="4" stroke="currentColor" stroke-width="0.8"/>
      <path d="M 30 0.5 L 33 4 L 30 7.5 L 27 4 Z" fill="currentColor"/>
    </svg>`;
}

function coverHtml(book) {
  if (book.cover) {
    return `<img class="book_cover" src="${book.cover}" alt="Cover of ${book.title}" loading="lazy">`;
  }
  // Decorative placeholder when no cover is provided yet. Mimics a real
  // book spine: tiny series label on top, ornament, then the title set
  // in the display serif.
  return `
    <div class="book_cover book_cover--placeholder" aria-hidden="true">
      <span class="book_cover_label">${book.seriesName}</span>
      ${ornamentSvg()}
      <span class="book_cover_glyph">${book.title}</span>
    </div>`;
}

function retailersHtml(book) {
  const links = [];
  if (book.retailer.amazon) {
    links.push(
      `<a class="btn btn-small" href="${book.retailer.amazon}" target="_blank" rel="noopener">Read &ldquo;${book.title}&rdquo; on Amazon</a>`,
    );
  }
  return links.join('');
}

function cardHtml(book) {
  const seriesLabel = book.seriesNumber
    ? `${book.seriesName}, Book ${book.seriesNumber}`
    : `${book.seriesName} \u2014 Collection`;
  return `
    <li class="book_card reveal" data-book-id="${book.id}">
      <div class="book_cover_wrap">
        ${coverHtml(book)}
      </div>
      <div class="book_meta">
        <p class="book_series">${seriesLabel}</p>
        <h3 class="book_title">${book.title}</h3>
        <p class="book_blurb">${book.description || book.blurb}</p>
        <div class="book_actions">${retailersHtml(book)}</div>
      </div>
    </li>`;
}

export function renderBooks(target = '#books .book_grid') {
  const grid = document.querySelector(target);
  if (!grid) return;
  const ordered = [...books].sort((a, b) => a.order - b.order);
  grid.innerHTML = ordered.map(cardHtml).join('');
}

export function renderSeriesLink(target = '#books .series_link') {
  const link = document.querySelector(target);
  if (!link) return;
  link.setAttribute('href', series.amazon);
}
